import React, { useEffect } from 'react';
import { Container } from 'components/common';
import contact from 'assets/illustrations/contact.jpeg';
import { Wrapper, Details, Thumbnail } from './styles';
import ContactForm from './ContactForm';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";


export const Contact = () => {


  return (
    <Wrapper as={Container} id="contact">
      {/* <Thumbnail>
        <ScrollAnimation animateIn="animate__jackInTheBox" duration="3" >
          <img src={contact} alt="Contact me" /></ScrollAnimation>
      </Thumbnail> */}
      <Details>
        <ContactForm />
      </Details>

    </Wrapper>
  )

};
